import { LiveQuery } from '@dittolive/ditto'

/** Stops Ditto live query */
export const stopLiveQuery = (
  query: React.RefObject<LiveQuery | undefined> | undefined,
): void => {
  if (query?.current) {
    query.current.stop()
  }
}
